
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zakaznicky-servis",
      function () {
        return require("private-next-pages/zakaznicky-servis.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zakaznicky-servis"])
      });
    }
  